import { render, staticRenderFns } from "./FiltroFuncionarios.vue?vue&type=template&id=4d175a04&"
import script from "./FiltroFuncionarios.vue?vue&type=script&lang=js&"
export * from "./FiltroFuncionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports